export const INVOICES_TEXT = Object.freeze({
  page: {
    title: 'Facturación',
    subtitle: 'Control de facturas emitidas, cobranza y seguimiento documental.',
  },
  create: {
    page: {
      title: 'Facturar',
      subtitle: 'Genera una nueva factura con la información del cliente y sus conceptos.',
    },
    headerActions: {
      back: 'Regresar',
    },
    ui: {
      issuerCard: {
        title: 'Emisor',
      },
      infoCard: {
        title: 'Información fiscal',
        actions: {
          showIssuerInfo: 'Ver información del emisor',
          hideIssuerInfo: 'Ocultar información del emisor',
        },
        fields: {
          date: 'Fecha',
          series: 'Serie',
          folio: 'Folio',
          paymentMethod: 'Método de pago',
          paymentForm: 'Forma de pago',
          global: 'Global',
          globalPeriodicity: 'Periodicidad',
          globalExercise: 'Ejercicio',
        },
        placeholders: {
          date: 'Selecciona fecha',
          series: 'Selecciona serie',
          paymentMethod: 'Selecciona método',
          paymentForm: 'Selecciona forma',
          globalPeriodicity: 'Selecciona periodicidad',
          globalExercise: 'Selecciona ejercicio',
        },
        emptyValue: '-',
      },
      receiverCard: {
        title: 'Cliente / Receptor',
        toggle: {
          showNew: '+ Nuevo',
          showNewCustomer: '+ Nuevo cliente',
          hide: 'Ocultar',
        },
        placeholders: {
          selectorLocked: 'Selecciona dato de facturación del cliente',
          selectorSearch: 'Buscar por RFC, razón social o cliente',
          clientName: 'Nombre corto del cliente',
        },
        fields: {
          customer: 'Cliente',
          customerRequired: 'Cliente *',
          rfcRequired: 'RFC *',
          businessNameRequired: 'Razón social *',
          taxRegimeRequired: 'Régimen fiscal *',
          cfdiUseRequired: 'Uso de CFDI *',
          fiscalResidenceRequired: 'Dirección fiscal (C.P.) *',
          taxRegime: 'Régimen',
        },
        actions: {
          saveAndUse: 'Guardar y usar',
          saveAndUseCustomer: 'Guardar y usar cliente',
        },
        emptyState: 'Selecciona un cliente para ver detalles fiscales',
      },
      conceptsCard: {
        title: 'Conceptos',
        addButton: 'Concepto',
        menu: {
          title: 'Más acciones',
          cfdiRelated: 'CFDI Relacionados',
          addendas: 'Addendas',
          discount: 'Descuento',
        },
        table: {
          headers: {
            qty: 'CANT.',
            unit: 'UNIDAD',
            code: 'CÓDIGO',
            concept: 'CONCEPTO',
            unitValue: 'VAL. UNITARIO',
            taxes: 'IMPUESTOS',
            amount: 'IMPORTE',
            actions: 'ACCIONES',
          },
          empty: 'No hay ningún concepto añadido',
        },
        actions: {
          editConceptTitle: 'Editar concepto',
          deleteConceptTitle: 'Eliminar concepto',
        },
        toasts: {
          cfdiPending: 'CFDI Relacionados estará disponible en el siguiente paso.',
          discountPending: 'Descuento estará disponible en el siguiente paso.',
          addendasPending: 'Addendas estará disponible en el siguiente paso.',
        },
      },
      conceptModal: {
        titleCreate: 'Nuevo concepto',
        titleEdit: 'Editar concepto',
        subtitle: 'Captura la información del servicio y sus impuestos.',
        closeAriaLabel: 'Cerrar modal',
        modeSelector: {
          paymentPlan: 'Plan de pagos',
          manual: 'Concepto manual',
        },
        paymentPlan: {
          title: 'Agregar desde plan de pagos',
          subtitle: 'Selecciona conceptos asociados al cliente o negocio para agregarlos a la factura.',
          toolbar: {
            searchPlaceholder: 'Buscar por concepto, fecha o monto',
            businessPlaceholder: 'Selecciona negocio',
            allBusinesses: 'Todos los negocios',
          },
          summary: {
            selected: 'conceptos seleccionados',
            amount: 'Monto acumulado:',
            merge: 'Unificar conceptos',
            mergedDescription: 'Conceptos unificados desde plan de pagos',
          },
          table: {
            headers: {
              date: 'FECHA',
              concept: 'NOMBRE DEL CONCEPTO',
              business: 'NEGOCIO',
              amount: 'MONTO',
            },
            loading: 'Cargando conceptos de plan de pagos...',
            empty: 'No hay conceptos disponibles para los filtros seleccionados.',
            unknownBusiness: 'Negocio sin nombre',
          },
          actions: {
            add: 'Agregar',
          },
        },
        fields: {
          services: 'Servicios *',
          unit: 'Unidad *',
          concept: 'Concepto *',
          qty: 'Cantidad *',
          unitPrice: 'Precio unitario *',
        },
        placeholders: {
          service: 'Selecciona servicio',
          unit: 'Selecciona unidad',
          concept: 'Describe el concepto',
          qty: '0.00',
        },
        amounts: {
          title: 'Importes del concepto',
          subtitle: 'Captura cantidad, precio unitario e impuestos del concepto.',
        },
        actions: {
          submitCreate: 'Agregar',
          submitEdit: 'Actualizar',
        },
        validation: {
          serviceRequired: 'Selecciona un servicio.',
          unitRequired: 'Selecciona una unidad.',
          descriptionRequired: 'Captura la descripción del concepto.',
          qtyInvalid: 'La cantidad debe ser mayor a 0.',
          unitPriceInvalid: 'El precio unitario debe ser mayor o igual a 0.',
          taxSelectionRequired: 'Selecciona un impuesto o un grupo de impuestos.',
        },
        serviceOption: {
          titlePrefix: 'Servicio',
          codePrefix: 'Código',
          conceptPrefix: 'Concepto',
          noType: 'Sin tipo',
          noName: '-',
        },
      },
      bottomSection: {
        commentsTitle: 'Comentarios',
        commentsPlaceholder: 'Añade términos de pago, instrucciones especiales o notas para el cliente...',
      },
      footerActions: {
        submit: 'Facturar',
      },
    },
    receiver: {
      validation: {
        receiverRequiredToEdit: 'Selecciona un receptor válido para editar.',
        customerRequiredToUpdate: 'No se pudo resolver el cliente para actualizar sus datos de facturación.',
      },
      toast: {
        loadContributorError: 'No fue posible cargar los datos de facturación.',
      },
    },
    prefill: {
      defaultConceptDescription: 'Concepto de plan de pago',
      defaultUnitCode: 'H87',
      defaultUnitName: 'Pieza',
      defaultSatCode: '81102702',
    },
    validation: {
      companyRequired: 'Selecciona un receptor válido con cliente relacionado.',
      contributorRequired: 'Selecciona un receptor con datos fiscales.',
      serialRequired: 'Selecciona una serie válida para facturar.',
      conceptsRequired: 'Agrega al menos un concepto para emitir la factura.',
      unitCodeRequired: 'Todos los conceptos deben tener unidad SAT.',
      satCodeRequired: 'Todos los conceptos deben tener código SAT.',
    },
    toast: {
      prefillReceiverWarning: 'No se pudo cargar automáticamente el receptor del plan de pago. Selecciónalo para continuar.',
      prefillLoadError: 'No fue posible cargar la información del plan de pago para facturar.',
      conceptsCleared: 'Conceptos eliminados.',
      previewPending: 'Vista previa disponible en el siguiente paso.',
      inlineBillingDataCreated: 'Dato de facturación agregado y seleccionado.',
      inlineBillingDataCreateError: 'No fue posible crear el dato de facturación.',
      inlineCustomerCreated: 'Cliente agregado y seleccionado.',
      inlineCustomerCreateError: 'No fue posible crear el cliente con sus datos de facturación.',
      invoiceCreateError: 'No fue posible emitir la factura. Intenta nuevamente.',
      invoiceReferenceFallback: 'sin folio',
      invoiceCreated: (reference) => `Factura ${reference} emitida correctamente.`,
    },
  },
  detail: {
    page: {
      title: 'Factura',
      dateFallback: '-',
      customerPending: 'Cliente pendiente',
    },
    sectionTabsAriaLabel: 'Secciones del detalle de factura',
    tabs: {
      detail: 'Detalle',
      shipping: 'Envíos',
      documents: 'Documentos',
      history: 'Historial',
    },
    breadcrumb: {
      ariaLabel: 'Ruta de factura',
      backLabel: 'Volver',
      invoiceWord: 'Factura',
      invoicesListRoot: 'Facturas',
      salesRoot: 'Negocios',
      customersRoot: 'Clientes',
      billingRoot: 'Facturación',
      invoicesRoot: 'Todas las facturas',
      saleFallback: 'Negocio',
    },
    tabPanels: {
      shipping: {
        title: 'Envíos',
        subtitle: 'Registro cronológico de envíos y su estatus para esta factura.',
      },
      documents: {
        title: 'Documentos',
        subtitle: 'Próximamente se listarán archivos y documentos relacionados con esta factura.',
      },
      history: {
        title: 'Historial',
        subtitle: 'Registro cronológico de movimientos y cambios de la factura.',
      },
    },
    header: {
      moreActionsTitle: 'Más acciones',
    },
    status: {
      active: 'VIGENTE',
      canceled: 'CANCELADA',
    },
    cards: {
      fiscalSummary: {
        title: 'Resumen fiscal',
        sections: {
          emitter: 'Emisor',
          receiver: 'Receptor',
          info: 'Información',
        },
        fields: {
          receiverRfc: 'RFC receptor',
          businessName: 'Razón social',
          rfc: 'RFC',
          fiscalResidence: 'Dirección fiscal (C.P.)',
          issueDate: 'Fecha de emisión',
          currencyExchange: 'Moneda / Tipo de cambio',
          date: 'Fecha',
          folio: 'Folio',
          uuid: 'UUID',
          paymentMethod: 'Método de pago',
          paymentForm: 'Forma de pago',
        },
        actions: {
          showAll: 'Ver todo',
          showLess: 'Ver menos',
        },
      },
      operation: {
        title: 'Operación',
        fields: {
          status: 'Estado',
          relatedPayments: 'Pago',
          balance: 'Saldo',
          pendingBalance: 'Saldo pendiente',
          customerShort: 'Cliente',
          dueDate: 'Vencimiento',
          customer: 'Cliente asociado',
          sale: 'Negocio asociado',
          sent: 'Enviada',
          lastSent: 'Último envío',
          comments: 'Comentarios',
        },
        values: {
          payment: 'Pago',
          pay: 'Pagar',
          sent: 'Enviada',
          notSent: 'Sin enviar',
          noLastSent: 'Sin registro',
          noCustomer: 'Sin cliente relacionado',
          noSale: 'Sin negocio Relacionado',
        },
        actions: {
          showMore: 'Ver más',
          showLess: 'Ver menos',
        },
      },
      totals: {
        title: 'Totales',
        fields: {
          subtotal: 'Subtotal',
          taxes: 'Impuestos',
          total: 'TOTAL',
        },
      },
      info: {
        title: 'Información',
        fields: {
          date: 'Fecha',
          folio: 'Folio',
          paymentMethod: 'Método de pago',
          paymentForm: 'Forma de pago',
        },
      },
      receiver: {
        title: 'Receptor',
      },
    },
    headerActions: {
      download: 'Descargar',
      send: 'Enviar',
      downloadXml: 'Descargar XML',
      clone: 'Clonar',
      sendWhatsapp: 'Enviar por WhatsApp',
      cancel: 'Cancelar',
    },
    toast: {
      loadInvoiceError: 'No fue posible consultar el detalle de la factura.',
      missingInvoiceData: 'No se encontraron datos para mostrar el detalle de la factura.',
      actions: {
        download: 'Descarga de factura disponible en el siguiente paso.',
        downloadXml: 'Descarga de XML disponible en el siguiente paso.',
        downloadPdf: 'Descarga de PDF disponible en el siguiente paso.',
        clone: 'Clonado de factura disponible en el siguiente paso.',
        sendWhatsapp: 'Envío por WhatsApp disponible en el siguiente paso.',
        cancel: 'Cancelación de factura disponible en el siguiente paso.',
      },
    },
  },
  history: {
    title: 'Historial de la factura',
    subtitle: 'Registro cronológico de movimientos y cambios de la factura.',
    loading: 'Cargando historial de la factura...',
    empty: 'Sin movimientos registrados en el historial.',
    table: {
      headers: {
        index: '#',
        date: 'Fecha',
        module: 'Módulo',
        event: 'Evento',
        description: 'Descripción',
        user: 'Usuario',
      },
    },
    fallback: {
      date: '-',
      module: 'General',
      event: 'Cambio',
      description: 'Actividad registrada',
      actor: 'Sistema',
    },
  },
  shipping: {
    title: 'Envíos de la factura',
    subtitle: 'Seguimiento de intentos de envío, estatus y responsables.',
    loading: 'Cargando envíos de la factura...',
    empty: 'Sin envíos registrados para esta factura.',
    table: {
      headers: {
        index: '#',
        date: 'Fecha',
        module: 'Canal',
        event: 'Estatus',
        description: 'Descripción',
        user: 'Usuario',
      },
    },
    fallback: {
      date: '-',
      module: 'Correo',
      event: 'Pendiente',
      description: 'Envío registrado',
      actor: 'Sistema',
    },
  },
  headerActions: {
    invoice: 'Facturar',
    exportExcel: 'Exportar',
    exportDownload: 'Descargar',
  },
  toasts: {
    exportExcelPending: 'La exportación a Excel se conectará en el siguiente paso.',
    downloadRequestCreated: 'Tu solicitud de descarga fue registrada y comenzará a procesarse en segundo plano.',
    downloadRequestError: 'No fue posible preparar la descarga de documentos.',
    downloadPackageError: 'No fue posible descargar el paquete seleccionado.',
    retryPackageSuccess: 'El paquete se marcó para reintento.',
    retryPackageError: 'No fue posible reintentar el paquete.',
    regenerateSuccess: 'Se generó una nueva solicitud con los parámetros de la descarga anterior.',
    regenerateError: 'No fue posible generar nuevamente la descarga.',
    openDetailError: 'No se pudo abrir el detalle de la factura.',
    pendingAction: 'Se está trabajando en ello.',
    invoiceReferenceFallback: 'sin folio',
    payInvoice: (reference) => `Pagar factura: ${reference}`,
    downloadXml: (reference) => `Descargar XML: ${reference}`,
    downloadFiles: (reference) => `Descargar documentos: ${reference}`,
    downloadPdf: (reference) => `Descargar PDF: ${reference}`,
    uploadReceipt: (reference) => `Subir comprobante: ${reference}`,
    cloneInvoice: (reference) => `Clonar factura: ${reference}`,
  },
  downloadModal: {
    title: 'Descargar documentos',
    closeAriaLabel: 'Cerrar modal de descarga de documentos',
    contextMessage: 'Se descargarán los documentos correspondientes a los resultados de la pestaña y filtros actuales.',
    lastDownloadTitle: 'Última descarga',
    fallbackScopeLabel: 'Facturas',
    resultsFound: (count) => `Se encontraron ${count} facturas con los filtros actuales.`,
    noResultsMessage: 'No se encontraron facturas para proceder con la descarga.',
    documentTypeLabel: 'Tipo de documento a descargar',
    documentTypes: {
      pdf: 'PDF',
      xml: 'XML',
      both: 'PDF + XML',
    },
    groupByLabel: 'Agrupar por:',
    groupByOptions: {
      customer: 'Cliente',
      month: 'Mes',
      none: 'Sin agrupar',
    },
    packageLimitHint: (limit) => `Límite por paquete: ${limit} facturas. Si se supera, se generarán múltiples paquetes automáticamente.`,
    expiryHint: (hours) => `Disponible durante ${hours} horas.`,
    availableUntil: (value) => `Disponible hasta ${value}.`,
    summaryLine: (documentType, count) => `${documentType} · ${count} facturas`,
    packageLine: (index, total) => `Paquete ${index} de ${total}`,
    preparing: {
      title: 'Preparando tu descarga',
      keepWorking: 'Puedes esperar aquí o cerrar esta ventana y continuar trabajando. La descarga seguirá preparándose aunque cierres esta ventana.',
      packageProgress: (completed, total) => `Preparando paquete ${Math.min(completed + 1, Math.max(total, 1))} de ${Math.max(total, 1)}...`,
    },
    expiredMessage: 'Descarga expirada. Los archivos de esta descarga ya no están disponibles.',
    status: {
      pending: 'Pendiente',
      processing: 'Preparando',
      completed: 'Listo',
      partialFailed: 'Parcial con errores',
      failed: 'Error',
      expired: 'Expirada',
    },
    actions: {
      close: 'Cerrar',
      refresh: 'Actualizar estado',
      download: 'Descargar',
      downloading: 'Descargando...',
      downloadPackage: 'Descargar',
      retryPackage: 'Reintentar',
      regenerate: 'Generar nuevamente',
    },
  },
  exports: {
    modal: {
      title: 'Exportar facturas',
      subtitle: 'Selecciona la información que deseas incluir en el archivo Excel. Puedes guardar esta configuración para utilizarla nuevamente.',
      format: {
        title: 'Formato de exportación',
        selectorLabel: 'Formato',
        selectorPlaceholder: 'Selecciona una opción',
        newOption: 'Nuevo formato',
        save: 'Guardar formato',
        saveAs: 'Guardar como',
        delete: 'Eliminar formato',
        saving: 'Guardando...',
        deleting: 'Eliminando...',
        nameLabel: 'Nombre del formato',
        namePlaceholder: 'Ej. Facturas pendientes de cobro',
        nameRequired: 'Debes capturar el nombre del formato.',
        duplicateConfirm: 'Ya existe un formato con ese nombre. ¿Deseas reemplazarlo?',
        deleteConfirm: '¿Deseas eliminar este formato de exportación?',
        copySuffix: 'copia',
      },
      columns: {
        title: 'Columnas a exportar',
        subtitle: 'Activa las columnas que deseas incluir en el archivo. El orden de selección se respeta en el Excel.',
        selectAll: 'Todas',
        clearSelection: 'Limpiar',
        restoreDefault: 'Restaurar',
        selectedCount: (count) => `${count} columna${count === 1 ? '' : 's'} seleccionada${count === 1 ? '' : 's'}`,
        orderTitle: 'Orden de columnas',
        orderSubtitle: 'Ajusta el orden con los controles de subir y bajar.',
        orderEmpty: 'No hay columnas seleccionadas.',
      },
      groups: {
        general: 'Información general',
        customer: 'Cliente y negocio',
        fiscal: 'Información fiscal',
        financial: 'Importes',
        payment: 'Cobranza',
        follow_up: 'Seguimiento',
      },
      footer: {
        cancel: 'Cancelar',
        saveAndExport: 'Guardar y exportar',
        exportOnly: 'Exportar',
        exporting: 'Exportando...',
      },
      toast: {
        loadError: 'No fue posible cargar la configuración de exportación.',
        noColumns: 'Debes seleccionar al menos una columna para exportar.',
        formatSaved: 'Formato de exportación guardado correctamente.',
        formatUpdated: 'Formato de exportación actualizado correctamente.',
        formatDeleted: 'Formato de exportación eliminado correctamente.',
        formatError: 'No fue posible guardar el formato de exportación.',
        formatDeleteError: 'No fue posible eliminar el formato de exportación.',
        exportSuccess: 'Exportación de facturas generada correctamente.',
        exportError: 'No fue posible exportar las facturas.',
      },
    },
    settings: {
      deleteModal: {
        title: 'Eliminar formato de exportación',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (formatName) => `Formato: ${formatName}. ¿Deseas eliminar este formato de exportación? Esta acción no se puede deshacer.`,
        confirm: 'Eliminar',
      },
      table: {
        actions: {
          delete: 'Eliminar',
        },
      },
    },
  },
  metrics: {
    totalInvoiced: 'Total facturado',
    subtotal: 'Subtotal',
    transferredTaxes: 'Impuestos',
    withheldTaxes: 'Retenciones',
    totalCollected: 'Total cobrado',
    pendingBalance: 'Saldo pendiente',
    averageInvoice: 'Factura promedio',
    overdueInvoices: 'Facturas vencidas',
  },
  toolbar: {
    searchPlaceholder: 'Buscar por folio, cliente, negocio o UUID',
    filtersButtonTitle: 'Filtros',
    searchButtonTitle: 'Buscar',
    emptyOption: 'Sin opción disponible',
    selectorOptions: {
      yes: 'Sí',
      no: 'No',
      invoiceTypes: {
        nacional: 'Nacional',
        exportacion: 'Exportación',
        egreso: 'Egreso',
      },
    },
    dateRangePresets: [
      { key: 'this_month', label: 'Este mes' },
      { key: 'last_month', label: 'Mes anterior' },
      { key: 'this_year', label: 'Año actual' },
      { key: 'last_year', label: 'Año anterior' },
    ],
    allOptionLabels: {
      customer: 'Cliente: Todos',
      hasBusiness: 'Todos',
      business: 'Todos',
      hasReceivedProof: 'Todos',
      invoiceType: 'Todos',
    },
    selectionAllLabels: {
      customer: 'Cliente: Todos',
      hasBusiness: 'Todos',
      business: 'Todos',
      hasReceivedProof: 'Todos',
      invoiceType: 'Todos',
    },
    filters: {
      customer: { label: 'Cliente', placeholder: 'Selecciona cliente', searchable: true },
      hasBusiness: { label: 'Tiene negocio relacionado', placeholder: 'Selecciona opción', searchable: false },
      business: { label: 'Negocio', placeholder: 'Selecciona negocio', searchable: true },
      hasReceivedProof: { label: 'Tiene comprobante de recibido', placeholder: 'Selecciona opción', searchable: false },
      invoiceType: { label: 'Tipo de factura', placeholder: 'Selecciona tipo', searchable: false },
    },
  },
  tabs: {
    all: 'Vigentes',
    pending: 'Pendientes',
    partial: 'Parcialmente pagada',
    paid: 'Pagadas',
    canceled: 'Canceladas',
  },
  table: {
    loading: 'Cargando facturas...',
    empty: 'Sin facturas para los filtros seleccionados.',
    sortTitles: {
      date: 'Ordenar por fecha',
      customer: 'Ordenar por cliente',
      subtotal: 'Ordenar por subtotal',
      total: 'Ordenar por total',
      balance: 'Ordenar por saldo',
    },
    columns: {
      date: 'FECHA',
      customer: 'CLIENTE',
      folio: 'FOLIO',
      subtotal: 'SUBTOTAL',
      transferedTaxes: 'TRASLADADOS',
      withheldTaxes: 'RETENIDOS',
      total: 'TOTAL',
      balance: 'SALDO',
      status: 'ESTADO',
      payment: 'PAGO',
    },
    links: {
      customerDetail: 'Ir al detalle del cliente',
      saleDetail: 'Ir al detalle del negocio',
    },
    labels: {
      uuid: 'UUID',
      noUuid: 'Sin UUID',
      multiclient: 'Multicliente',
      exchangeRatePrefix: 'TC:',
      emptyValue: '',
    },
    actions: {
      viewInvoice: 'Ver factura',
      pay: 'Pagar',
      download: 'Descargar',
      downloadXml: 'Descargar XML',
      more: 'Más acciones',
      downloadPdf: 'Descargar PDF',
      uploadReceipt: 'Subir comprobante',
      cloneInvoice: 'Clonar',
    },
    statusPills: {
      paid: 'Pagada',
      partial: 'Parcialmente pagada',
      pending: 'Pendiente',
      canceled: 'Cancelada',
    },
    paymentPills: {
      paid: 'Pagado',
      partial: 'Parcial',
      pending: 'Pendiente',
      unpaid: 'Sin pago',
    },
  },
});
